import axios from 'axios';

const Axios = axios.create({
    baseURL: process.env.VUE_APP_BASEURL,
    // baseURL: 'http://localhost:8000',
    withCredentials: true,
});

export default Axios;
